import { getGlobalWindow } from './dom/global';

const window = getGlobalWindow();

export const isKarmaTestEnv = !!window && '__karma__' in window;
